<template>
  <div class="root row hcenter">
    <div class="card m-auto">
      <div class="card-content">
        <div class="statuses">
          <template v-if="apiStatus === 3">
            <StatusInfo
              status="error"
              :message="responseErrors"
              :timeout="10000"
            />
          </template>
          <template v-if="invalidToken">
            <StatusInfo
              status="error"
              message="Your session has expired and therefore need to login again"
              :timeout="10000"
            />
          </template>
          <template v-if="username">
            <status-info
              status="success"
              :message="`You can now login as ${username}`"
            />
          </template>
        </div>

        <form class="inputs" ref="fields-container" @submit.prevent="login">
          <!-- TODO find a way to use the value prop properly -->
          <InputField
            label="username"
            icon="account_circle"
            focusClass="text-white"
            :focus="true"
            :value="username"
            :error="errors.username"
            @keyup="handleKeys($event, 'username')"
          />
          <InputField
            label="password"
            iconClickable
            focusClass="text-white"
            :type="passwordInputType"
            :icon="passwordToggleIcon"
            :error="errors.password"
            @iconClick="togglePasswordVisibility"
            @keyup="handleKeys($event, 'password')"
          />

          <!-- <div class="input-field mb-1">
          <input type="checkbox" class="outline" id="remember-me" />
          <label for="remember-me">Remember Me</label>
          </div>-->
          <div class="mt-2">
            <button
              type="submit"
              class="block mb-2 waves"
              :class="apiStatus === 1 ? 'pulse' : null"
            >
              login
            </button>
          </div>
          <div class="input-field mb-0">
            <div class="mb-1">
              <router-link :to="{ name: 'ForgotPassword' }"
                >Forgot Password?</router-link
              >
            </div>
            <div class>
              <router-link :to="{ name: 'Signup' }">Sign Up</router-link>
              Instead?
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from "vuex";

import InputField from "@/components/InputField";
import StatusInfo from "@/components/StatusInfo";

export default {
  name: "Login",
  metaInfo() {
    return {
      title: "Login | Curio Travels",
    };
  },
  components: {
    InputField,
    StatusInfo,
  },
  props: {
    invalidToken: {
      type: Boolean,
      default: false,
    },
    // username: {
    //   type: String,
    //   default: ""
    // }
  },
  computed: {
    ...mapGetters({
      apiStatus: "Auth/getLoadingStatus",
      responseErrors: "Auth/getErrors",
    }),
  },
  data() {
    return {
      username: "",
      rerouteTo: "",
      passwordInputType: "password",
      passwordToggleIcon: "visibility",

      errors: {
        username: "",
        password: "",
      },
    };
  },
  mounted() {
    T.waves();

    // FIXME decouple the params into props instead
    const params = this.$route.params 
    this.username = params.username;
    this.rerouteTo = this.$route.query.to;

    console.log('Params: ', this.$route)
  },
  methods: {
    togglePasswordVisibility() {
      if (this.passwordInputType === "password") {
        this.passwordToggleIcon = "visibility_off";
        this.passwordInputType = "text";
      } else {
        this.passwordInputType = "password";
        this.passwordToggleIcon = "visibility";
      }
    },
    handleKeys(e, type) {
      if (e.key === "Tab" || e.key === "Shift") return;

      if (e.target.value.trim() !== "") this.errors[type] = "";
      else this.errors[type] = `Please enter your ${type}`;
    },

    login(e) {
      if (this.errors.username || this.errors.password) return;

      const form = e.target;
      const formData = new FormData(form);

      const username = formData.get("username");
      const password = formData.get("password");

      if (username && password) {
        const payload = {
          username,
          password,
        };

        this.$store
          .dispatch("Auth/login", payload)
          .then(() => {
            if (this.apiStatus === 2) {
              if (this.rerouteTo)
                this.$router.push(this.rerouteTo)
              else
                this.$router.push({ name: "Home" });
            }
          })
          .catch(() => {});
      }

      if (!username) this.errors.username = "Please enter your username";
      else this.errors.username = "";
      if (!password) this.errors.password = "Please enter your password";
      else this.errors.password = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.root .card {
  width: 100%;
  color: white;
  max-width: 330px;
  background-color: #000000da;

  @supports ((backdrop-filter: blur(20px))) {
    backdrop-filter: blur(20px);
    background-color: #000000a9;
    border: 2px solid #ffffff29;
  }
}
</style>
